import { Observable } from "rxjs";

import st from "lib/utils/index";
import { ReviewDecorator } from "lib/decorators/index";
import { ReviewsRepository } from "lib/repositories/index";
import { pushRoute } from "modules/app/actions";
import { createResourceInstance, createFormInstance } from "modules/utils/index";

export const OPEN = "reviews/EditReviewModal/OPEN";
export const CLOSE = "reviews/EditReviewModal/CLOSE";

export const LOAD_REVIEW = "reviews/EditReviewModal/LOAD_REVIEW";
export const FETCH_REVIEW = "reviews/EditReviewModal/FETCH_REVIEW";
export const FETCH_REVIEW_START = "reviews/EditReviewModal/FETCH_REVIEW_START";
export const FETCH_REVIEW_SUCCESS = "reviews/EditReviewModal/FETCH_REVIEW_SUCCESS";
export const FETCH_REVIEW_FAILURE = "reviews/EditReviewModal/FETCH_REVIEW_FAILURE";

export const INITIALIZE_MODEL = "reviews/EditReviewModal/INITIALIZE_MODEL";
export const UPDATE_MODEL = "reviews/EditReviewModal/UPDATE_MODEL";
export const VALIDATE = "reviews/EditReviewModal/VALIDATE";
export const SUBMIT = "reviews/EditReviewModal/SUBMIT";
export const FETCH_SUBMIT_START = "reviews/EditReviewModal/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "reviews/EditReviewModal/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "reviews/EditReviewModal/FETCH_SUBMIT_FAILURE";

export const REMOVE = "reviews/EditReviewModal/REMOVE";
export const FETCH_REMOVE_START = "reviews/EditReviewModal/FETCH_REMOVE_START";
export const FETCH_REMOVE_SUCCESS = "reviews/EditReviewModal/FETCH_REMOVE_SUCCESS";
export const FETCH_REMOVE_FAILURE = "reviews/EditReviewModal/FETCH_REMOVE_FAILURE";

export const stateSelector = (state) => state.reviews.EditReviewModal;

const resourceInstance = createResourceInstance({
  LOAD: LOAD_REVIEW,
  FETCH: FETCH_REVIEW,
  FETCH_START: FETCH_REVIEW_START,
  FETCH_SUCCESS: FETCH_REVIEW_SUCCESS,
  FETCH_FAILURE: FETCH_REVIEW_FAILURE,
  stateSelector,
  stateKey: "review",
  getModel: ({ reviewId }) => {
    return ReviewsRepository.find(reviewId);
  },
});

const removeResourceInstance = createResourceInstance({
  FETCH: REMOVE,
  FETCH_START: FETCH_REMOVE_START,
  FETCH_SUCCESS: FETCH_REMOVE_SUCCESS,
  FETCH_FAILURE: FETCH_REMOVE_FAILURE,
  stateSelector,
  stateKey: "removal",
  getModel: ({ reviewId }) => {
    return ReviewsRepository.delete(reviewId);
  },
});

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  validate: ({ form: { model: review } }, errors, { submitValidate }) => {
    // errors.add(`review.full_name`, st.validators.presence(review.full_name))
    // errors.add(`review.full_name`, st.validators.length(review.full_name, { minimum: 5, maximum: 100 }))
  },
  submitModel: ({ form: { model } }) => {
    return ReviewsRepository.update(model);
  },
});

const initialState = {
  opened: false,
  reviewId: null,
  review: resourceInstance.initialState,
  form: formInstance.initialState,
  removal: removeResourceInstance.initialState,
};

const reducers = {
  ...resourceInstance.reducersMap,
  ...formInstance.reducersMap,
  ...removeResourceInstance.reducersMap,

  [OPEN]: (state, { review }) => ({
    ...initialState,
    opened: true,
    reviewId: review.id,
  }),

  [CLOSE]: (state) => ({
    ...state,
    opened: false,
  }),
};

const epics = [
  ...resourceInstance.epics,
  ...formInstance.epics,
  ...removeResourceInstance.epics,

  (actions$) =>
    actions$
      .ofType(LOAD_REVIEW)
      .merge(actions$.ofType(FETCH_REVIEW_SUCCESS))
      .map(({ model }) => {
        return initializeModel(model);
      }),

  (actions$) => actions$.ofType(FETCH_SUBMIT_SUCCESS).merge(actions$.ofType(FETCH_REMOVE_SUCCESS)).mapTo(close()),
];

export const { initializeModel, updateModel: updateReview, validate, submit } = formInstance.actions;
export const { load: loadReview, fetch: fetchReview } = resourceInstance.actions;
export const { fetch: removeReview } = removeResourceInstance.actions;

export function open(review) {
  if (review === undefined) {
    review = ReviewDecorator.build();
  }

  return (dispatch, getState) => {
    const { opened, reviewId } = stateSelector(getState());
    if (!(opened && reviewId === review.id)) {
      dispatch({ type: OPEN, review });
      if (review.id && !review.type) {
        dispatch(fetchReview());
      } else {
        dispatch(loadReview(review));
      }
    }

    const location = getState().app.location;
    if (location.query.editReview != review.id) {
      dispatch(
        pushRoute({
          ...location,
          query: {
            ...location.query,
            editReview: review.id,
          },
        })
      );
    }
  };
}

export function close() {
  return (dispatch, getState) => {
    const { opened } = stateSelector(getState());
    if (opened) {
      dispatch({ type: CLOSE });
    }

    const location = getState().app.location;
    if (location.query.editReview) {
      dispatch(
        pushRoute({
          ...location,
          query: {
            ...location.query,
            editReview: undefined,
          },
        })
      );
    }
  };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/reviews/EditReviewModal/index.js